<template>
  <div class="bg-grey-lighter mt-6 px-2">
    <draggable v-model="media" class="flex flex-wrap justify-space-between -mx-2" @end="onEnd">
      <figure v-for="image in media" class="sm:w-1/3 px-2 my-2 relative group overflow-hidden hover:bg-grey-light flex justify-center items-center" :key="image.id">
        <div class="invisible group-hover:visible absolute z-10 bg-red hover:bg-red-darker hover:cursor-pointer text-white text-2xl font-bold leading-loose rounded-full h-8 w-8 flex items-center justify-center pin-t pin-r mt-1 mr-1" v-on:click="onDelete(image.id)">
          <svg class="fill-current w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M323.1 441l53.9-53.9c9.4-9.4 9.4-24.5 0-33.9L279.8 256l97.2-97.2c9.4-9.4 9.4-24.5 0-33.9L323.1 71c-9.4-9.4-24.5-9.4-33.9 0L192 168.2 94.8 71c-9.4-9.4-24.5-9.4-33.9 0L7 124.9c-9.4 9.4-9.4 24.5 0 33.9l97.2 97.2L7 353.2c-9.4 9.4-9.4 24.5 0 33.9L60.9 441c9.4 9.4 24.5 9.4 33.9 0l97.2-97.2 97.2 97.2c9.3 9.3 24.5 9.3 33.9 0z"/></svg>
        </div>
        <img :src="image.url" class="">
        <figcaption class="absolute pin-b invisible group-hover:visible bg-grey-darkest opacity-75 -mt-8 w-full block text-xs text-white">Drag to Reorder</figcaption>
      </figure>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  props: ['location'],
  components: {
    draggable
  },
  data() {
    return {
      media: []
    }
  },
  mounted() {
    this.getMedia()
  },
  methods: {
    getMedia() {
      axios.get('/api/v1/locations/' + this.location + '/media')
        .then(({data}) => {
          this.media = Object.values(data)
        })
    },
    onEnd(el) {
      this.refreshOrder()
    },
    onDelete(id) {
      axios.delete('/api/v1/locations/' + this.location + '/media/' + id)
        .then(() => {
          let media = this.media

          for (let i in media) {
            let image = media[i]
            if (image.id == id) {
              media.splice(i, 1)
            }
          }
          this.media = media

        })
        .then(() => {
          this.refreshOrder()
        })
    },
    refreshOrder() {
      let media = this.media
      for (let i in media) {
        let image = media[i]
        image.order_column = Number(i) + 1

        axios.patch('/api/v1/locations/' + this.location + '/media', {
          image: image
        })
      }
    }
  }
}
</script>

